import React, {Component} from 'react';
import { Trans } from 'react-i18next';
import { simpleGetRequest } from '../service/ApiService';
import i18n from '../resources/i18n';
import CircularProgress from '@material-ui/core/CircularProgress';

class IdPDFReuse extends Component {

  confirmSearch(){
    this.captureForSearch({ key: 'Enter', target: document.querySelector('#idpdf')});
  }

  checkDateRange(stringDate){
    let auxDate = new Date();
    auxDate.setHours(0,0,0,0);
    let auxYear = auxDate.getFullYear().toString();
    if(auxYear.substring(auxYear.length-2) === stringDate.substring(0,2) || (auxYear = (Number.parseInt(auxYear)-1).toString(),auxYear.substring(auxYear.length-2) === stringDate.substring(0,2))){
      let auxDif = (auxDate.getTime() - (new Date(auxYear,Number.parseInt(stringDate.substring(2,4))-1,stringDate.substring(4,6)).getTime()));
      if(auxDif>=0 && auxDif<=604800000){// 7 días
        return true;
      }
    }
    return false;
  }

  captureForSearch(event){
    if(event.key ==="Enter"){
      //this.showCarrito = false;
      const tempTarget = event.target;
      tempTarget.parentElement.parentElement.children.item(1).style.display="";
      tempTarget.parentElement.children.item(2).style.display="";
      tempTarget.parentElement.children.item(3).style.display="";
      tempTarget.classList.remove("errorRed");
      if(tempTarget.value.length !== 0){
        let searchThisPDF = tempTarget.value;
        if(/^\d{6}-\d{9}-[FMP]{1}$/.test(searchThisPDF)){
          if(this.checkDateRange(searchThisPDF.substring(0,6))){//confirm Date
            tempTarget.parentElement.parentElement.children.item(1).style.setProperty('display', 'block', 'important');
            fetch('/conectorMAC/getPDFByID?printID=' + searchThisPDF, {
              method: 'GET',
              headers: {
                'Range': 'bytes=0-1'
              }
            }).then((res) => {

              if (res.ok) { // status 200 o 206
                tempTarget.classList.remove("errorRed");
                window.location.href = '/mapaalacarta/IdPDFReuse?ID=' + searchThisPDF;
              } else { // 404/500 error
                tempTarget.classList.add("errorRed");
                tempTarget.parentElement.children.item(3).style.display="block";
                tempTarget.parentElement.parentElement.children.item(1).style.display="";
              }

            }).catch((err) => { // errores de red
              console.log('ERROR:', err);
              tempTarget.classList.add("errorRed");
              tempTarget.parentElement.children.item(3).style.display="block";
              tempTarget.parentElement.parentElement.children.item(1).style.display="";
            });
            // simpleGetRequest('/conectorMAC/getPDFByID?printID=' + searchThisPDF).then((res)=>{

            //   if(res.status === 200){
            //     tempTarget.classList.remove("errorRed");
            //     window.location.href = '/mapaalacarta/IdPDFReuse?ID=' + searchThisPDF;
            //   } else {//404/500 error
            //     tempTarget.classList.add("errorRed");
            //     tempTarget.parentElement.children.item(3).style.display="block";
            //   }
            // }).catch((err)=>{//404/500 error
            //   console.log('ERROR:',err);
            //   tempTarget.classList.add("errorRed");
            //   tempTarget.parentElement.children.item(3).style.display="block";
            //   tempTarget.parentElement.parentElement.children.item(1).style.display="";
            // });
          }else{// Out of Date
            tempTarget.classList.add("errorRed");
            tempTarget.parentElement.children.item(3).style.display="block";
          }
        } else {//Wrong ID format
          tempTarget.classList.add("errorRed");
          tempTarget.parentElement.children.item(2).style.display="block";
        }
      }
    }
  }

  //<div className="errorRed duplicateerror">*<Trans i18nKey="dialog.duplicateerror">Ya presente en el carrito</Trans></div>
  render() {
    return (
      <div className='idpdfreuse-container'>
        <Trans i18nKey="dialog.oldExplained">Buscar o encargar un mapa generado anteriormente (7 días)</Trans>
        <div className="flx-grw"/>
        <div className='texts-row-simple' style={{display: 'flex'}}>
              <div className="texts">
                <input type="text" id="idpdf" name="pdfidentifier" maxLength="18" placeholder='230921-871440078-F' onKeyDownCapture={this.captureForSearch.bind(this)} spellCheck="false" required="required"/>
                <label htmlFor="idpdf">{i18n.t('dialog.idoldpdf')}</label>
                <div className="errorRed validerror">*<Trans i18nKey="dialog.validerror">Formato no valido</Trans></div>
                <div className="errorRed existanceerror">*<Trans i18nKey="dialog.existanceerror">No existe tal PDF</Trans></div>
              </div>
              <CircularProgress className='searchProgress'/>
              <button className="searchPDF" onClick={this.confirmSearch.bind(this)}>
                <Trans i18nKey="dialog.search">Buscar</Trans>
              </button>
            </div>
      </div>
    );
  }
}

export default IdPDFReuse;
